<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('candidates.title')" icon="briefcase">
            <app-default-button
                v-if="$can('create_candidates')"
                :title="$addLabel('candidate')"
                @click="openCandidateModal()"
            />
        </app-page-top-section>

        <app-table
            id="candidate-table"
            :options="options"
            @action="triggerActions"
        />

        <app-candidate-modal
            v-if="isCandidateModalActive"
            v-model="isCandidateModalActive"
            :selected-url="selectedUrl"
        />
        <app-candidate-note-modal
            v-if="isCandidateNoteModalActive"
            v-model="isCandidateNoteModalActive"
            :candidateId="candidateId.toString()"
        />

        <app-confirmation-modal
            :message="promptSubtitle"
            :modal-class="modalClass"
            :icon="promptIcon"
            v-if="confirmationModalActive"
            modal-id="app-delete-confirmation-modal"
            @confirmed="triggerConfirm"
            @cancelled="cancelled"
        />

        <app-candidate-move-modal
            v-if="isCandidateMovementModalActive"
            v-model="isCandidateMovementModalActive"
            :candidate-id="candidateId"
        />


    </div>
</template>

<script>
import CandidateMixin from "../../../Mixins/Recruitment/CandidateMixin";
import {urlGenerator,axiosDelete} from "../../../../../common/Helper/AxiosHelper";
import {CANDIDATEWEB} from "../../../../Config/ApiUrl";

export default {
    name: "Candidates",
    mixins: [CandidateMixin],
    data() {
        return {
            candidate: '',
            candidateId: '',
            candidates: [],
            selectedUrl: '',
            modalClass: '',
            promptIcon: '',
            promptSubtitle: '',
            candidateName: '',
            candidateUsers: '',
            isCandidateModalActive: false,
            isCandidateNoteModalActive: false,
            confirmationModalActive: false,
            isCandidateMovementModalActive: false,
        }
    },
    created() {
        this.$store.dispatch('getStatuses', 'candidate')
    },
    watch: {
        isCandidateModalActive: function (value) {
            if (!value) {
                this.selectedUrl = '';
            }
        }
    },
    methods: {
        openCandidateModal() {
            this.selectedUrl = '';
            this.isCandidateModalActive = true;
        },
        triggerActions(row, action, active) {
            this.candidateId = row.id;
            this.promptIcon = action.icon;
            this.modalClass = action.modalClass;
            this.promptSubtitle = action.promptSubtitle;

            if (action.name === 'edit') {
                this.selectedUrl = `${action.url}/${row.id}`;
                this.isCandidateModalActive = true;
            }
            if (action.name === 'add-note') {
                this.isCandidateNoteModalActive = true;
                this.candidateId = row.id;
            }
            if (action.key === 'view_details') {
                window.location = urlGenerator(`${CANDIDATEWEB}/${row.id}`)
                // Add logic to handle view details action
            }
            if (action.key === 'delete_candidate') {
                this.confirmationModalActive = true;
                this.promptAction = action.key;
                this.deleteUrl = `${this.apiUrl.CANDIDATES}/${row.id}`
                this.promptTitle = this.$t('are_you_sure');
                this.promptMessage = this.$t('candidates.you_are_going_to_remove_an_candidate_from_list');
            }
            else if (['deactivate', 'activate'].includes(action.key)) {
                this.confirmationModalActive = true;
            } else if (action.name === 'convert-to-employee') {
                this.candidateId = row.id;
                this.candidateName = row.name;
                this.isCandidateMovementModalActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },
        closeConfirmation() {
            $("#app-confirmation-modal").modal('hide');
            $(".modal-backdrop").remove();
            this.loading = false;
            this.confirmationModalActive = false;
            // window.location.reload();
        },
        triggerConfirm() {
            if (this.promptAction === 'delete_candidate') {
                this.removeCandidate(this.deleteUrl);
            }
        },
        removeCandidate(url) {
            this.loading = true;
            // Change axiosPatch to axiosDelete for deletion
            axiosDelete(url)
                .then(({data}) => {
                    this.confirmationModalActive = false;
                    this.toastAndReload(data.message, 'candidate-table');
                }).catch(({response}) => {
                this.toastException(response.data);
                this.confirmationModalActive = false;
            }).finally(() => this.closeConfirmation());
        }
    }
}
</script>
